/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CopyLeadRequest
 */
export interface CopyLeadRequest {
    /**
     * 
     */
    facility_ids: Array<string>;
}

/**
 * Check if a given object implements the CopyLeadRequest interface.
 */
export function instanceOfCopyLeadRequest(value: object): value is CopyLeadRequest {
    if (!('facility_ids' in value) || value['facility_ids'] === undefined) return false;
    return true;
}

export function CopyLeadRequestFromJSON(json: any): CopyLeadRequest {
    return CopyLeadRequestFromJSONTyped(json, false);
}

export function CopyLeadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CopyLeadRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'facility_ids': json['facility_ids'],
    };
}

export function CopyLeadRequestToJSON(json: any): CopyLeadRequest {
    return CopyLeadRequestToJSONTyped(json, false);
}

export function CopyLeadRequestToJSONTyped(value?: CopyLeadRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'facility_ids': value['facility_ids'],
    };
}

